<template>
  <v-content v-if="sizeW">
    <background v-if="!selectedMenu"/>
    <table
      class="table-main"
      cellspacing="0"
      style="z-index:102;"
      :style="{ 'background-color': BGColor }"
    >
      <tr>
        <td
          class="simulation"
          :style="{ 'background-color': BGColor,
                    width: `${menuWidth}px !important`
                  }"
        >
          <div class="simulation-content"
            :style="{ 'background-color': BGColor }"

               >
          <a @click="handleMenuClick(null)" >
            <v-img
              v-if="logo"
              :src="logo"
              width="`${menuWidth}px`"
              heigth="auto"
              alt="logo"
              style="margin-bottom: 30px;"
            />
          </a>
      <div
        v-dragscroll.y
        style="overflow-y:scroll;"
        :style="{ height: !logo ? '980px' : '796px'}"
      >
          <custom-menu
            v-if="menus"
            :data="menus.filter(x => x.IsActive && !x.HideDesktop && x.Availability.status.date && x.Availability.status.time)"
            :onMenuChange="handleMenuClick"
            style="margin-top:0;right: 0px; max-width:360px !important;"
          />
          <br />
            <back-button :isMain="true" :isMenu="true" />
          <br/>
            <center style="color: #FFFFFF33;">{{info}}</center>
          <br/>
      </div>
          </div>
        </td>
        <td id="mainForm" v-resize="onResize" 
        >
          <custom-content
            v-if="selectedMenu"
            :menu="selectedMenu"
          />
          <div
            v-else
            :style="{ 'width' : `${sizeW}px`}"
          />
        </td>
      </tr>
    </table>
  </v-content>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import api from '@/services/api'
import statsService from '@/services/stats'
import utils from '@/services/utils'

  import CustomMenu from './menu/Index'
  import CustomContent from './content/Index'
  import Background from './Background'
  import BackButton from '@/components/BackButton'
export default {
  directives: {
    dragscroll
  },
  components: {
    Background,
    CustomMenu,
    CustomContent,
    BackButton,
  },
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    menus: null,
    selectedMenu: null,
    menuWidth: 360,
    sizeW: null,

    logo: null,
    BGColor: null,
  }),
  computed: {
    domain () {
      return utils.getDomain()
    },
    info () {
      return process.env.VUE_APP_INFOSORT
    },
  },
  watch: {
    enterprise () {
      this.prepareTotem()
    },
  },
  mounted () {
    this.prepareTotem()
  },
  methods: {
    onResize () {
      const aux = document.body.offsetWidth - this.menuWidth
      this.$store.state.app.mainFormWidth = aux
    },    
    prepareTotem () { 
      this.selectedMenu = null
      this.sizeW = window.innerWidth - this.menuWidth
      this.BGColor = this.enterprise.BGColor
      this.logo = this.$store.state.app.totemBackDomain ? this.enterprise.Logo : null // if linkDomain show logo else hide logo

      this.handleGetMenus()
    },
    handleGetMenus () {
      api.getAll(`menus`, false, null, null, null, this.enterprise.Domain).then(response => {
        response = response.filter(x => !x.HideTotem)
        response = response.map (item => {
          if (item.Menus) {
            item.Menus = item.Menus.map(submenu => {
              submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
              return submenu
            })
            item.Menus = item.Menus.filter(x => x.Availability.status.time && x.Availability.status.date)
          }
          item.Availability = utils.checkAvailabilityStatus(item.Availability)
          return item
        })
        this.menus = response.filter(x => !x.Private && x.Availability && x.Availability.status.time && x.Availability.status.date)
      })
    },
    handleMenuClick (menu) {
      statsService.addStat({ WorkspaceID: this.enterprise.ID, MenuID: menu.ID, Locale: this.$store.state.app.locale })

      if (menu) this.$store.state.app.expandMenuID = menu.ID
      //if (!menu) window.location.href = '/#/?'.concat(`&locale=${this.locale}`, this.touchPublic ? '&touchPublic=true' : '', this.isPI ? '&PI=true' : '', this.back ? `&back=${this.back}` : '', this.forceIMG ? '&forceIMG=true' : '')
      this.selectedMenu = menu
    }
  },
}
</script>
<style lang="scss">
.main-body-totem::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

#mainForm {
  height: 50%;
  overflow-y: scroll;
}
  h1 {
    font-weight: normal;
  }
  .table-main {
    width: 100%;
    height: 980px !important;
    /*
    min-height: calc(100vh);
    */
    z-index: 110;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }

  .simulation::-webkit-scrollbar { 
    width: 0 !important;
    display: none; 
  }
  .simulation {
    width: 360px;
    padding: 0;
  }
  .simulation-content {
    position:fixed;
    width: 360px;
    padding: 0;
    /* overflow: hidden; */
    max-height: 100vh;
    height: 980px !important;
    overflow-y: scroll;
  }
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; 
  } 
  /* Hide scrollbar for Chrome, Safari and Opera */
  .simulation-content::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .simulation-content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  } 
</style>

